"use client"

import * as SwitchPrimitive from "@radix-ui/react-switch"

import { cn } from "../utils"

function Switch({
  className,
  ref,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      className={cn(
        `
          peer
          focus-visible:ring-ring
          inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2
          border-transparent transition-colors ease-[var(--ease-standard)]
          focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background
          focus-visible:outline-none
          disabled:cursor-not-allowed disabled:opacity-50
          data-[state=checked]:bg-primary/40
          data-[state=unchecked]:bg-primary/20
        `,
        className,
      )}
      {...props}
      ref={ref}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          `
            pointer-events-none block size-5 rounded-full bg-background shadow-lg ring-0
            transition-transform ease-[var(--ease-standard)]
            data-[state=checked]:translate-x-5
            data-[state=unchecked]:translate-x-0
          `,
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
